/**
 * Prefer ServiceWorkerRegistration.showNotification (works more reliably when the tab is in the background),
 * then fall back to the window Notification constructor.
 */
export async function showRemoteJoinNotification({ body, onPageNotification }) {
  if (typeof window === 'undefined' || !window.isSecureContext) return false;

  const opts = {
    body,
    tag: 'deckpack-remote-pending',
    renotify: true,
  };

  if ('serviceWorker' in navigator) {
    try {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg?.active) {
        await reg.showNotification('Deck Pack Remote', opts);
        return true;
      }
    } catch (err) {
      console.warn('Deck Pack: service worker notification failed', err);
    }
  }

  try {
    if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return false;
    const n = new Notification('Deck Pack Remote', opts);
    if (typeof onPageNotification === 'function') onPageNotification(n);
    return true;
  } catch (err) {
    console.warn('Deck Pack: page notification failed', err);
    return false;
  }
}
